<template lang="pug">
.y-select
  v-select.text-sm.round-xl(v-model="modelValue" :items="items" :item-text="itemText" :item-value="itemValue" :placeholder="placeholder" outlined :rules="rules" hide-details="auto" :loading="loading" @change="change" append-icon="$yzi-chevron-down" :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', contentClass: 'select-menu' }" :dense="dense" :no-data-text="noDataText")
    
</template>

<script>
export default {
  props: {
    value: {
      default: undefined
    },
    items: {
      default: undefined
    },
    itemText: {
      default: 'name'
    },
    itemValue: {
      default: 'id'
    },
    placeholder: {
      default: null
    },
    rules: {
      default: () => []
    },
    loading: {
      default: false
    },
    dense: {
      default: false
    },
    noDataText: {
      default: '$vuetify.noDataText'
    }
  },
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    change () {
      this.$emit('change')
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
::v-deep .v-input__icon {
  min-width: 22px;
  width: 22px;
}
</style>